// Can be invoked and imported on server and CLIENT
export function securelyGetGitHash() {
  return "test12"

  // TODO REPO MIGRATE

  // // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  // return typeof window === "undefined"
  //   ? (() => {
  //       // eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment
  //       const getGitHash = require("./getCommitHash").getGitHash
  //       // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return
  //       return getGitHash()
  //     })()
  //   : undefined
}
